export const SAVE = 'step7.SAVE';
export const VALUE_CHANGED = 'step7.VALUE_CHANGED';
export const LOAD = 'step7.VALUE_LOAD';
export const NEXT = 'step7.NEXT';
export const RESET = 'step7.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'step7.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'step7.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'step7.RESET_COMPENSATION';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '7',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step7/constants.js